<template>
  <div>
    <div class="row no-gutters">
      <div class="col map-wrapper">
        <!-- Map Start -->
        <div class="mainmap" id="mainmap" ref="mainmap"></div>
        <div class="minimap" style="display:none;" id="minimap"></div>
        <!-- Map End -->
      </div>
      <div class="col panorama-wrapper" v-show="showPanorama">
        <div class="video-top-right">
          <a class='screenshot-button' @click = 'downloadScreenshot'>
            <img src="@/assets/img/screenshot_icon.svg" class="img-fluid m-2 mr-3" width="18">
          </a>
          <a class="close-button" @click="closePanorama">
            <img src="@/assets/img/close_icon.svg" class="img-fluid m-2" width="14">
          </a>
        </div>
        <div class="displayYaw">
          Azimuth {{panoramaYaw}}, Tilt {{panoramaPitch}}, Altitude {{droneAltitude}}
          </div>

        <div @keydown="updateYaw" @mousedown="updateYaw" @mouseup="updateYaw" id="panorama" ref="panorama"></div>
      </div>
    </div>

    <!-- Successful Comment Message -->
    <div v-if="commentSuccess">
      <displayGlobalMessage v-if="commentSuccess" :message='"Issue Successfully Created"'></displayGlobalMessage>
    </div>
  </div>
</template>

<script>
import L from 'leaflet';
import Vue from 'vue';
import api from '@/api';
import 'leaflet-measure';
import 'leaflet-draw';
import domtoimage from 'dom-to-image';
import { mapMutations, mapState } from 'vuex';

import { POSITION_TIME_DATA_SETTERS } from '@/config';
import popup from '@/components/popup.vue';
import { getClosestIndexFromLatLng } from '@/utils/posDataOperations';
import displayGlobalMessage from '@/components/displayGlobalMessage.vue';
import commentCreate from '@/components/commentCreate.vue';

// TODO: Standardize Marker Names
import mainDroneMarker from '@/assets/img/mainmap/drone_black.svg';
import miniDroneMarker from '@/assets/img/mainmap/drone_mini1.svg';
import commentsMarker from '@/assets/img/mainmap/comments_marker.svg';
import mapmarker from '@/assets/img/mapmarker_black.svg';
import mapmarkerimage from '@/assets/img/map_marker_image.png';
import mapmarkerNotification from '@/assets/img/image_marker_notification.svg';


export default {
  props: ['pid', 'sid', 'did'],
  components: {
    displayGlobalMessage,
  },
  data() {
    return {
      mainmap: '',
      minimap: '',
      mainmapTileLayer: '',
      mainmapDroneMarker: '',
      mainmapPolylineLayer: '',
      minimapDroneMarker: '',
      minimapPolylineLayer: '',
      subsection: '',
      wmsOrtLayer: '',
      wmsDsmLayer: '',
      commentsLayer: '',
      imagesLayer:'',
      zoomControl: '',
      commentSuccess: false,
      mainmapImagesLayer: '',
      isSchematic: false,
      chainageProject: false,
      measureControl: '',
      drawControl: '',
      // measureControl: '',
      showPanorama: false,
      pannellumViewer: {},
      panoramaYaw: 0,
      panoramaPitch: 0,
      droneAltitude: 0,
    };
  },
  mounted() {
    this.initMap();
    this.initPannellum();
    this.plotPolylineLayers();
    this.plotImagesOnMap();
    this.plotCommentsOnMap();
    this.setMapObject(this.mainmap);
    // console.log(L.latLng(50.5, 30.5));
  },
  computed: {
    ...mapState([
      'isLayerOrtVisible',
      'isLayerDsmVisible',
      'isLayerDrwVisible',
      'isCommentsVisible',
      'isVideosVisible',
      'isImagesVisible',
      'isAllProjectDataVisible',
      'isCommentOnMapEnabled',
      'currentProject',
      'currentSubsection',
      'globalPosData',
      'positionTimeData',
      'positionTimeDataCache',
      'positionTimeDataCacheWatch',
      'commentsData',
      'projectVideos',
      'projectVideosLoaded',
      'projectLayers',
      'projectDsms',
      'commentDataWatch',
      'commentsDataCache',
      'projectImages',
      'isVideoPlayerVisible',
      'mapCoords',
    ]),
  },
  watch: {
    isSchematic() {
      this.mainmap.removeControl(this.drawControl);
      this.mainmap.removeControl(this.measureControl);
    },
    mapCoords() {
      if (!this.mapCoords.lat) { return; }
      this.mainmap.setView(this.mapCoords, 20)
    },
    commentDataWatch() {
      this.plotCommentsOnMap();
    },
    projectVideosLoaded() {
      this.plotPolylineLayers();
      if (this.projectVideosLoaded.length == this.projectVideos.length) {
        NProgress.done();
      }
    },
    projectLayers() {
      this.redrawLayers();
    },
    projectDsms() {
      this.redrawLayers();
    },
    projectImages() {
      this.plotImagesOnMap();
      this.plotCommentsOnMap();
    },
    isLayerOrtVisible() {
      this.toggleOrtLayerOnMap();
    },
    isLayerDsmVisible() {
      this.toggleDsmLayerOnMap();
    },
    isCommentsVisible() {
      // this.toggleCommentsVisibilityOnMap();
      this.plotCommentsOnMap();
    },
    isVideosVisible() {
      this.plotPolylineLayers();
    },
    isImagesVisible() {
      this.plotImagesOnMap();
      this.plotCommentsOnMap();
    },
    isCommentOnMapEnabled() {
      this.toggleCommentOnMap();
    },
    isAllProjectDataVisible() {
      this.plotPolylineLayers();
      this.plotImagesOnMap();
      this.plotCommentsOnMap();
    },
    globalPosData() {
      const latlng = L.latLng(
        this.globalPosData.lat,
        this.globalPosData.lng,
      );
      this.minimap.panTo(latlng);
      if (this.globalPosData.setter !== POSITION_TIME_DATA_SETTERS.MAP) {
        this.updateMarkerLocation(latlng);
      }
    },
    positionTimeData() {
      // TODO: Move the drone to the correct line here. ??
      // this.plotPositionTimeData();
      // this.plotPolylineLayers();
    },
    currentProject() {
      this.getSubsectionData();
      Array.from(this.currentProject.project_features).forEach((feat) => {
        if (feat.feature_name == 'isSchematicOrtho' && feat.enabled) {
          this.isSchematic = true;
          this.mainmap.setMinZoom(20);
        } else if(feat.feature_name == 'chainageProject' && feat.enabled) {
          this.chainageProject = true;
       // this.mainmapTileLayer.setUrl('https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}');
        }
      })
    },
    did() {
      this.plotPolylineLayers();
      this.plotImagesOnMap();
      this.plotCommentsOnMap();
      this.fitMapBounds();
    },
    isVideoPlayerVisible() {
      // If the video player is opened, then fit map bounds again in 
      // such a way that both path and video are visible. Need not 
      // fitBounds on video close. Should be okay.
      if (this.isVideoPlayerVisible) {
        this.fitMapBounds();
      }
    },
    positionTimeDataCacheWatch() {
      this.fitMapBounds();
    },
  },
  methods: {
    ...mapMutations([
      'setGlobalPosData',
      'setCurrentSid',
      'setCurrentDid',
      'addToLayerDetails',
      'toggleCommentOnMapTool',
      'setMapObject',
    ]),

    initPannellum() {
      this.pannellumViewer = pannellum.viewer('panorama', {
        "scenes": {},
        "compass": true,
        //  "hotSpotDebug": true,
      });
    },
    
    updateYaw(event) {
      if (String.fromCharCode(event.keyCode) === 'p' || String.fromCharCode(event.keyCode) === 'P') {
        this.downloadScreenshot();        
      } else {    
        if(this.pannellumViewer.getYaw() < 0) {
          this.panoramaYaw = (parseFloat(this.pannellumViewer.getYaw()+this.pannellumViewer.getNorthOffset()).toFixed(2));          
        } else {
          this.panoramaYaw = parseFloat(this.pannellumViewer.getYaw()+this.pannellumViewer.getNorthOffset()).toFixed(2);
          if(this.pannellumViewer.getScene() === 1302) {
            if(this.panoramaYaw > 360) {
              this.panoramaYaw = (this.panoramaYaw - 360).toFixed(2);
            }
          }
        }
        this.panoramaPitch = parseFloat(this.pannellumViewer.getPitch()).toFixed(2);   
      }  
    },    
    downloadScreenshot() {     
      let screenshotUrl = this.pannellumViewer.getRenderer().render(this.pannellumViewer.getPitch()/180*Math.PI,
                                                                  this.pannellumViewer.getYaw()/180*Math.PI,
                                                                  this.pannellumViewer.getHfov()/180*Math.PI,
                                                                  {'returnImage': true});      
      let img = new window.Image();
      img.setAttribute('id', 'image');     
      img.setAttribute("src", screenshotUrl);
      document.getElementById('mainmap').appendChild(img);
      let screenshotImage =  document.getElementById('image');    
      setTimeout(()=>{
        const canvas = document.createElement('canvas');       
        canvas.width = screenshotImage.width;
        canvas.height = screenshotImage.height;       
        const context = canvas.getContext('2d');        
        context.drawImage(screenshotImage, 0, 0);        
        let text = `Azimuth ${this.panoramaYaw}, Tilt ${this.panoramaPitch}, Altitude ${this.droneAltitude}`;        
        context.font = '20px Roboto';
        context.fillStyle = 'white';
        context.shadowColor = '#000000';
        context.shadowBlur = 10;
        context.strokeStyle = 'black';
        context.lineWidth = 8;
        context.strokeText(text, canvas.width/2-150, canvas.height-50);
        context.fillText(text, canvas.width/2-150, canvas.height-50);        
        const canvasurl = canvas.toDataURL('image/png');        
        const link = document.createElement('a');
        link.href = canvasurl;
        link.download = `screenshot_${this.panoramaYaw}_${this.panoramaPitch}.png`;
        link.click();
      }, 1000);     
       document.getElementById('mainmap').removeChild(img);
    },

    closePanorama() {
      this.showPanorama = false;
      this.toggleCommentOnMapTool(true);
    },

    redrawLayers() {
      if (!this.wmsOrtLayer) { return; }
      // TODO: Instead of clearLayers, we can probably check if the layer is
      // already added, and if not then add. This will need an extra list that
      // is storing the names of all the added layers.
      // This is all the project layers will be added immediately after currentProject
      // has been loaded. So its unlikely to cause too much of an issue
      this.wmsOrtLayer.clearLayers();
      Array.from(this.projectLayers).forEach((data) => {
        let layer_info = data.layer;
        if (layer_info.length < 2) {
          // console.log('layer info is incorrectly save on backend');
          // In forEach, there is no continue, there is only return
          return;
        }

        let layer = null;
        let layerDetail = {};
        let layerMetadata = layer_info[0].split(':');
        if (layerMetadata[0] == 'tms') {
          // If we're not using wms, then we can directly serve tiles.
          layer = L.tileLayer(layer_info[1], {
            tms: true,
            maxZoom: 24,
          });
          // FIXME: Need to this elsewhere
          this.mainmap.setMaxZoom(24);
          } else if (layerMetadata[0] == 'xyz') {
          // If we're not using wms, then we can directly serve tiles.
          layer = L.tileLayer(layer_info[1], {
            maxZoom: 24,
          });
          // FIXME: Need to this elsewhere
          this.mainmap.setMaxZoom(24);
        } else {
          layer = L.tileLayer.wms(layer_info[1], {
            layers: layer_info[0],
            format: 'image/png',
            tiled: true,
            transparent: true,
            maxZoom: 24,
            version: '1.1.0',
            crs: L.CRS.EPSG900913,
            zIndex: 2,
            subdomains: ['1', '2', '3', '4'],
          });
        }
        if(layer_info.length > 2) {
          // FIXME: Will add layer controls to Map Controls menu only if we have vectors.
          // This should be updated.
          layerDetail.id = data.data_id;
          layerDetail.layerName = layerMetadata[1];
          layerDetail.layerObject = layer;
          layerDetail.isVisible = true;
        }
        this.wmsOrtLayer.addLayer(layer);

        if(layer_info.length > 2) {
          // console.log('length is greater than 2', layer_info.length);
          // This implies that we have vector layers attached to ortho
          layerDetail.vectorLayers = [];
          for(let i = 2; i<layer_info.length ; i++) {
            let geoJsonURL = layer_info[i];
            api.downloadJSON(geoJsonURL)
            .then((response) => {
              if(response.status === 200) {
                let vectorLayer = L.geoJSON( response.data, {
                  style: function(feature) {
                    if(feature.properties['fill'] ||
                       feature.properties['fill-opacity'] ||
                       feature.properties['stroke'] ||
                       feature.properties['stroke-width'] ||
                       feature.properties['stroke-opacity']) {
                         return {
                          fillColor: feature.properties['fill'],
                          fillOpacity: feature.properties['fill-opacity'],
                          color: feature.properties['stroke'],
                          width: feature.properties['stroke-width'],
                          opacity: feature.properties['stroke-opacity']
                        }
                       }
                    
                    if(feature.properties.CATEGORY == 'Cracks' ||
                       feature.properties.CATEGORY == 'Damaged'||
                       feature.properties.CATEGORY == 'Leakage'||
                       feature.properties.CATEGORY == 'Damages' ) {
                      return {color: '#f06031', fillOpacity:0}
                    }
                    switch (feature.geometry.type) {
                        case 'Polygon': return {color: "#2980b9", fillOpacity:0};
                        case 'LineString': return {color: "#27ae60", fillOpacity:0};
                        case 'MultiPolygon': return {color: "red", fillOpacity:0};
                    }
                  },
                  pointToLayer: function (feature, latlng) {
                    return L.circleMarker(latlng, { radius: 2, color: "red", weight: 3,opacity: 1 });
                  },
                  onEachFeature: (feature, layer) => {
                    if (feature.properties) {
                      let popupContent = '';
                      for(let property in feature.properties) {
                        if(feature.properties.hasOwnProperty(property) &&
                          (property != 'FID' &&
                           property !='Id' &&
                           property !='fill' &&
                           property !='fill-opacity' &&
                           property !='stroke' &&
                           property !='stroke-width' &&
                           property !='stroke-opacity')) {
                          popupContent += `${property}: ${feature.properties[property]}</br>`
                        }
                      }
                      if(popupContent){
                        layer.bindPopup(`${popupContent}`);
                      }
                    }
                  }
                });
                // FIXME: Ideally we should not use 'i' as vector ID. It should come from backend.
                layerDetail.vectorLayers.push({id:i, name: response.data.name, vectorObject: vectorLayer, isVisible:true});
                this.wmsOrtLayer.addLayer(vectorLayer);
                // this.mainmap.removeLayer(vectorLayer);
                // this.mainmap.addLayer(i);
              }
            });
          }
          
          this.addToLayerDetails(layerDetail);
        }
      })

      // This is called as we want to view/hide the layer based on isLayerOrtVisible
      this.toggleOrtLayerOnMap();

      // FIXME: Drawing dsm layers. !!! IMP !!! Should be refactored with above !!!IMP!!!.
      if (!this.wmsDsmLayer) { return; }
      this.wmsDsmLayer.clearLayers();
      Array.from(this.projectDsms).forEach((data) => {
        let layer_info = data.layer;
        if (layer_info.length < 2) {
          // console.log('layer info is incorrectly save on backend');
          // In forEach, there is no continue, there is only return
          return;
        }
        let layer = null;
        let layerMetadata = layer_info[0].split(':');
        if (layerMetadata[0] == 'tms') {
          // If we're not using wms, then we can directly serve tiles.
          layer = L.tileLayer(layer_info[1], {
            tms: true,
            maxZoom: 24,
          });
          // FIXME: Need to this elsewhere
          this.mainmap.setMaxZoom(24);
          } else if (layerMetadata[0] == 'xyz') {
          // If we're not using wms, then we can directly serve tiles.
          layer = L.tileLayer(layer_info[1], {
            maxZoom: 24,
          });
          // FIXME: Need to this elsewhere
          this.mainmap.setMaxZoom(24);
        } else {
          layer = L.tileLayer.wms(layer_info[1], {
            layers: layer_info[0],
            format: 'image/png',
            tiled: true,
            transparent: true,
            maxZoom: 24,
            version: '1.1.0',
            crs: L.CRS.EPSG900913,
            zIndex: 2,
            subdomains: ['1', '2', '3', '4'],
          });
        }

        this.wmsDsmLayer.addLayer(layer);
      })
      // This is called as we want to view/hide the layer based on isLayerOrtVisible
      this.toggleDsmLayerOnMap();
    },

    getSubsectionData() {
      // FIXME: this.subsection doesn't seem to be used anywhere
      if (!this.currentProject.subsections) { return; }
      this.subsection = this.currentSubsection;
      this.setMapViewBasedOnProjectData();
    },
    // Map related Functions start
    initMap() {
      // TODO: Add Attribution to maps
      
      // Initialize map
      this.mainmap = L.map('mainmap', {
        attributionControl: false,
        zoomControl: false,
      })//.setView([0, 0], 3);
      

      // L.control.measure({
      //   position: 'topleft',
      // }).addTo(this.mainmap);

      // Add zoom control to topright corner
      this.zoomControl = L.control.zoom({
        position: 'topright',
      });

      this.zoomControl.addTo(this.mainmap);
      // Create a tilelayer
      this.mainmapTileLayer = L.tileLayer('https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v11/tiles/{z}/{x}/{y}?access_token=pk.eyJ1Ijoic293amFueWFlbm5hbSIsImEiOiJjamk1dnRta3Uwb2FyM3FtcmRkM2h0Z2gwIn0.2Fuzb-3EnJBBgzCcWHwKfw', {
       attribution: '© <a href="https://www.mapbox.com/feedback/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        },
        {
          maxZoom: 24,
          subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
        }
      );

      let drawnItems = new L.FeatureGroup();
      this.mainmap.addLayer(drawnItems);
      let drawPluginOptions = {
        position: 'topright',
        draw: {
          polygon: {
            allowIntersection: false,
            showArea: true, // Restricts shapes to simple polygons
            drawError: {
              color: '#e1e100', // Color the shape will turn when intersects
              message: '<strong>Oh snap!<strong> you can\'t draw that!' // Message that will show when intersect
            },
            shapeOptions: {
              color: '#97009c'
            }
          },
          // disable toolbar item by setting it to false
          polyline: false,
          circle: false, // Turns off this drawing tool
          rectangle: false,
          marker: false,
          circlemarker:false,
        },
        edit: false,
      };  
      this.drawControl = new L.Control.Draw(drawPluginOptions);
      this.mainmap.addControl(this.drawControl);
      
      let polygoncoordinates = [];
      let centerofpolygon, area='';
      this.mainmap.on('draw:created', function(e) {               
        let type = e.layerType;        
        drawnItems.addLayer(e.layer);        
        centerofpolygon = e.layer.getBounds().getCenter();                
        let getcoordinates = e.layer.getLatLngs();
        area = L.GeometryUtil.geodesicArea(getcoordinates[0]);      
        for(var latlng of getcoordinates[0]){          
          polygoncoordinates.push({'lat':latlng.lat,'lng':latlng.lng});          
        }            
      });      
      this.mainmap.on('draw:drawstop', (e) => {         
        let polygonCoordinates = polygoncoordinates;
        polygoncoordinates = [];
        let layerDid = null;
        if (this.projectLayers.length) {
          layerDid = this.projectLayers[0].data_id
        } else {
          // TODO: Get some other did here
          layerDid = this.did;
        }
        let createPopup = drawnItems.bindPopup("Bind Popup", {'className': 'sd-map-popup', },);
        this.takeMapScreenshot().then((commentImage)=> {
            createPopup.setPopupContent(
              this.commentcreatePopupDesign(
                {
                  latlng: centerofpolygon,
                  subsectionDataId: layerDid,
                  commentPopupHandler: createPopup,
                  commentImage: commentImage,
                  polygonCoordinates: polygonCoordinates,              
                })
            );
          createPopup.openPopup();
        });
        createPopup.on('popupclose', (e) => {          
          createPopup.unbindPopup();          
          this.mainmap.removeLayer(e.layer);                     
        });         
        drawnItems = new L.FeatureGroup();         
        this.mainmap.addLayer(drawnItems);
      });

      // Add the created tilelayer to map
      this.mainmapTileLayer.addTo(this.mainmap);

      this.wmsOrtLayer = new L.featureGroup();
      this.mainmap.addLayer(this.wmsOrtLayer);

      this.wmsDsmLayer = new L.featureGroup();
      this.mainmap.addLayer(this.wmsDsmLayer);
     
      // const mapmarkerIcon = L.icon({
      //   iconUrl: mapmarker,
      //   iconSize: [20, 26.4],
      //   popupAnchor: [0, 0],
      //   // iconAnchor: [0, 0],
      // });

      // this.mainmap.on('click', (e) => {
      //   new L.marker(
      //     e.latlng,
      //     { icon: mapmarkerIcon },
      //   ).addTo(this.mainmap);
      // });

      // Add minimap
      this.minimap = L.map('minimap', {
        zoomControl: false,
      }).setView([12.971599, 77.594566], 12);

      const minimapTileLayer = L.tileLayer('https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v11/tiles/{z}/{x}/{y}?access_token=pk.eyJ1Ijoic293amFueWFlbm5hbSIsImEiOiJjamk1dnRta3Uwb2FyM3FtcmRkM2h0Z2gwIn0.2Fuzb-3EnJBBgzCcWHwKfw', {
       attribution: '© <a href="https://www.mapbox.com/feedback/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        },
        {
          maxZoom: 24,
          subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
        }
     );

      minimapTileLayer.addTo(this.minimap);

      this.mainmapPolylineLayer = new L.featureGroup();
      this.mainmap.addLayer(this.mainmapPolylineLayer);

      this.mainmapImagesLayer = new L.featureGroup();
      this.mainmap.addLayer(this.mainmapImagesLayer);

      this.minimapPolylineLayer = new L.featureGroup();
      this.minimap.addLayer(this.minimapPolylineLayer);

      this.commentsLayer = new L.featureGroup();
      this.mainmap.addLayer(this.commentsLayer);

      this.imagesLayer = new L.featureGroup();
      this.mainmap.addLayer(this.imagesLayer);
      this.measureControl = L.control.measure({
        position: 'topright',
        primaryLengthUnit: 'meters',
        primaryAreaUnit:'sqmeters',
        activeColor: '#000',
        completedColor: 'red',
      });
      this.measureControl.addTo(this.mainmap);

      
      const mainDroneIcon = L.icon({
        iconUrl: mainDroneMarker,
        iconSize: [25, 30],
        iconAnchor: [12, 15],
      });
      this.mainmapDroneMarker = L.marker([0, 0], {
        draggable:'true',
        icon: mainDroneIcon,
      }).addTo(this.mainmap).on('click', (e) => {
          this.polylineClickHandler(e);
        }).on('dragend',(e)=>{
          var latlng=this.mainmapDroneMarker.getLatLng();
          this.DronemarkerDragHandler(latlng); 
        }).on('drag',()=>{
          this.$root.$emit('pausevideo');
        });
      const miniDroneIcon = L.icon({
        iconUrl: miniDroneMarker,
        iconSize: [30, 30],
        iconAnchor: [15, 15],
      });
      this.minimapDroneMarker = L.marker([0, 0], {
        draggable:'true',
        icon: miniDroneIcon,
      }).addTo(this.minimap);
      // console.log('map loaded emitting')
    },

    commentcreatePopupDesign(data) {      
      let latlng = data.latlng;
      let subsectionDataId = data.subsectionDataId;
      let commentPopupHandler = data.commentPopupHandler;
      let commentImage = data.commentImage;
      let videoTime = '0.0';
      let polygonCoordinates = data.polygonCoordinates;      
      const Popup = Vue.extend(commentCreate);
      const createCommentcontent = new Popup({
        propsData: {
          latlng,
          subsectionDataId,
          commentPopupHandler,
          commentImage,          
          videoTime,
          polygonCoordinates,
        },
        parent: this,
      });
      createCommentcontent.$on('commentCreateSuccess', ()=>{        
        this.commentSuccess = true;
        setTimeout(() => {
          this.commentSuccess = false;
        }, 3000);
        commentPopupHandler.closePopup();
      });
      return createCommentcontent.$mount().$el;
    },

    plotImagesOnMap() {
      // NOTE: Every time we plot images, we also want to plot comments
      // This is because we want the comments to be drawn on top of images
      this.mainmapImagesLayer.clearLayers()
      if (!this.isImagesVisible) { return; }
      const imagemarkerIcon = L.icon({
        iconUrl: mapmarkerimage,
        iconSize: [20, 26.4],
        popupAnchor: [0, 0],
        // iconAnchor: [0, 0],
      });
      Array.from(this.projectImages).forEach((data) => {
        // NOTE: Image can be normal image or panorama image.
        // Use layertype to distinguish between normal image and panorama image. 
        if(this.isAllProjectDataVisible || this.dataInCurrentSubsection(data.data_id)) {
          const latlng = L.latLng(
            data.image_coordinate[0],
            data.image_coordinate[1]
          );

          if(data.layer_type === "panorama") {
            const panMarker = L.marker(latlng, {icon: imagemarkerIcon}).addTo(this.mainmapImagesLayer);
            this.pannellumViewer.addScene(data.data_id, {
              "type": "equirectangular",
              "panorama": data.image,
            });
            
            this.pannellumViewer.on('load',() => {
              if(this.pannellumViewer.getScene() === 1305) {                
                this.pannellumViewer.setNorthOffset(180);
                this.droneAltitude = '6';
              }
              else if(this.pannellumViewer.getScene() === 1302) {                
                this.pannellumViewer.setNorthOffset(320);
                this.droneAltitude = '3';
              }
            });            
            if(data.layer.length>1) {
                this.droneAltitude = data.layer[3],
                this.pannellumViewer.addHotSpot({
                  "pitch": data.layer[0],
                  "yaw": data.layer[1],
                  "type": "info",
                  "text": `<img class="img-fluid" src="${data.layer[2]}" width="200px">`,
                }, data.data_id);
            }

            panMarker.on('click', () => {
              if(!this.showPanorama) {
                this.showPanorama = true;
                this.toggleCommentOnMapTool(false);
              }
              this.pannellumViewer.loadScene(data.data_id, 0, 0, 60);
            });
          } else {
            // Handle Normal Image

            const imageMarker = L.marker(
                  latlng,
                  { icon: imagemarkerIcon },
                ).addTo(this.mainmapImagesLayer);

            const imagePopup = imageMarker.bindPopup(
              "Bind Popup",
              {
                'className': 'sd-map-popup',
              },
            );

            imagePopup.setPopupContent(
              this.commentPopupDesign(
                {
                  latlng: latlng,
                  subsectionDataId: data.data_id,
                  commentPopupHandler: imagePopup,
                  commentImageURL: data.image,
                  imageMarker,
                })
            );
          }
        }
      });


    },
    toggleCommentOnMap() {
      if(this.isCommentOnMapEnabled) {
        const mapmarkerIcon = L.icon({
          iconUrl: mapmarker,
          iconSize: [20, 26.4],
          popupAnchor: [0, 0],
          // iconAnchor: [0, 0],
        });

        this.mainmap.on('click', (e) => {
          const pointerLatlng = e.latlng;
          const commentMarker = L.marker(
            pointerLatlng,
            { icon: mapmarkerIcon },
          ).addTo(this.mainmap);

          const commentPopup = commentMarker.bindPopup(
            "Bind Popup",
            {
             'className': 'sd-map-popup',
            },
          );
          // To get data id, we will have to get from store
          // By default we will use the first available layer
          // If not, we will use first available did in project
          let layerDid = null;
          if (this.projectLayers.length) {
            layerDid = this.projectLayers[0].data_id
          } else {
            // TODO: Get some other did here
            layerDid = this.did;
          }
          this.takeMapScreenshot().then((commentImage)=> {
            commentPopup.setPopupContent(
              this.commentPopupDesign(
                {
                  latlng: pointerLatlng,
                  subsectionDataId: layerDid,
                  commentPopupHandler: commentPopup,
                  commentImage: commentImage,
                })
            );
            commentPopup.openPopup();
          });

          commentPopup.on('popupclose', (e) => {
            commentPopup.unbindPopup();
            commentMarker.remove();
          });
        });
      } else {
        this.mainmap.off('click');
      }
    },

    toggleCommentsVisibilityOnMap() {
      return;
      if (!this.isCommentsVisible) {
        this.mainmap.getPane('commentsPane').style.display = 'none';
      } else {
        this.mainmap.getPane('commentsPane').style.display = 'block';
      }
    },

    toggleOrtLayerOnMap() {
      if (!this.isLayerOrtVisible) {
        this.wmsOrtLayer.eachLayer((layer) => {
          // console.log(layer);
          if (layer instanceof L.GeoJSON) {
            layer.setStyle({opacity:0});
            // layer.on('click', function(e) {
            //   e.stopPropagation();
            //   return false;
            // });
          } else {
            layer.setOpacity(0.0);
          }
        })
      } else {
        this.wmsOrtLayer.eachLayer((layer) => {
          if (layer instanceof L.GeoJSON) {
            layer.setStyle({opacity:1});
          } else {
            layer.setOpacity(1.0);
          }
        })
      }
    },

    toggleDsmLayerOnMap() {
      if (!this.isLayerDsmVisible) {
        this.wmsDsmLayer.eachLayer((layer) => {
          layer.setOpacity(0.0);
        })
      } else {
        this.wmsDsmLayer.eachLayer((layer) => {
          layer.setOpacity(1.0);
        })
      }
    },
    toggleDsmLayerOnMapa() {
      /*
      if (!this.isLayerDsmVisible) {
        this.wmsDsmLayer.remove();
      } else {
        this.wmsDsmLayer = L.tileLayer.wms('https://gis1.skylarkdrones.com:4444/geoserver/wms', {
          layers: 'amalgam:Plant_count_Chive',
          format: 'image/png',
          tiled: true,
          transparent: true,
          maxZoom: 23,
          version: '1.1.0',
          crs: L.CRS.EPSG900913,
          zIndex: 2,
        }).addTo(this.mainmap);
      }
      */
    },

    takeMapScreenshot() {
      return new Promise((resolve, reject) => {
        this.toggleControlLayers(true);

        domtoimage.toPng(this.$refs['mainmap'], {width:this.mainmap.getSize().x, height:this.mainmap.getSize().y})
          .then((dataUrl) => {         
            var blobobj=this.dataURItoBlob(dataUrl);       
            this.toggleControlLayers(false);  
            // console.log('blob object',blobobj);        
            resolve(blobobj);     
        })
        .catch((error) => {    
          this.toggleControlLayers(false);   
          reject(error);
          console.error('oops, something went wrong! could not download file', error);
        });
      }); 
    },

    dataURItoBlob(dataURI) {
      var byteString = atob(dataURI.split(',')[1]);
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
      var ab = new ArrayBuffer(byteString.length);
      var dw = new DataView(ab);
      for(var i = 0; i < byteString.length; i++) {
        dw.setUint8(i, byteString.charCodeAt(i));
      }
      return new Blob([ab], {type: mimeString});
    },

    toggleControlLayers(enabled) {      
      if (enabled) {
        this.mainmap.removeControl(this.zoomControl);
        if(!this.isSchematic) {
          this.mainmap.removeControl(this.drawControl);
          this.mainmap.removeControl(this.measureControl);
        }
      } else {
        this.mainmap.addControl(this.zoomControl);
        if(!this.isSchematic) {
          this.mainmap.addControl(this.drawControl);
          this.mainmap.addControl(this.measureControl);          
        }        
      }      
    },

    setMapViewBasedOnProjectData() {
      if(!this.currentProject) { return; }
      this.minimap.setView([this.currentProject.latitude, this.currentProject.longitude]);
      // FIXME: Hardocded af.
      this.mainmap.setView([this.currentProject.latitude, this.currentProject.longitude], 20);
      this.mainmap.on('click', (e) => {
      })
      // FIXME: Hardocded af.
    },
    
    checkSubsectionDataType(did) {
      if(!this.projectImages) {return}

      let isTrue = false;
      Array.from(this.projectImages).forEach((data) => {
        if(data.data_id === Number(did)){
          isTrue = true;
        }
      });
      return isTrue;
    },

    plotCommentsOnMap() {
      // Remove comments layer if its already present (Deletes unwanted comments)

        // Check if this is working
      this.commentsLayer.clearLayers();
      if(!this.isCommentsVisible) {return;}
      // Create comments Icon
      const commentsIcon = L.icon({
        iconUrl: commentsMarker,
        iconSize: [20, 20],
        popupAnchor: [0, 0],
        iconAnchor: [10, 10],
      });

      // Create image icon
      const imageMarkerIcon = L.icon({
        iconUrl: mapmarkerNotification,
        iconSize: [25, 30],
        popupAnchor: [0, 0],
        // iconAnchor: [10, 10],
      });

      // Create a feature group for all comments
      const markers = [];
      for (let dataId in this.commentsDataCache) {
        Array.from(this.commentsDataCache[dataId]).forEach((comment) => {
          let isMapMarker = this.checkSubsectionDataType(comment.subsection_data);
          let markerIcon = (isMapMarker) ? imageMarkerIcon: commentsIcon;

          if (this.isAllProjectDataVisible || this.dataInCurrentSubsection(comment.subsection_data)) {
            if(comment.coordinates.length > 1) {
              let polygonComment = L.polygon(comment.coordinates,{
                color: '#2980b9',
              })
                .bindPopup(this.commentPopupDesign({comment}), {'className': 'sd-map-popup'})
                .addTo(this.mainmap);
              
              this.commentsLayer.addLayer(polygonComment);
            } else {
              const id = comment.comment_id;
              markers[id] = L.marker([
                parseFloat(comment.latitude),
                parseFloat(comment.longitude),
              ], {
                icon: markerIcon,
              })
                .bindPopup(this.commentPopupDesign({comment}), {'className': 'sd-map-popup'})
                .addTo(this.mainmap);

              this.commentsLayer.addLayer(markers[id]);
            }
          }
        })
      }
    },

    // Programitically render component
    commentPopupDesign(data) {
      let comment = data.comment || null;
      let latlng = data.latlng || null;
      let subsectionDataId = data.subsectionDataId || null;
      let commentPopupHandler = data.commentPopupHandler || null;
      let commentImage = data.commentImage || null;
      let imageMarker = data.imageMarker || null;
      let commentImageURL = data.commentImageURL || null;
      // console.log(commentImage);
      const Popup = Vue.extend(popup);
      const popupComponent = new Popup({
        propsData: {
          comment,
          subsectionDataId,
          latlng,
          commentPopupHandler,
          commentImage,
          imageMarker,
          commentImageURL,
        },
        parent: this,
      });
      popupComponent.$on('IssueCreateSuccess', ()=>{
        this.commentSuccess = true;
        setTimeout(() => {
          this.commentSuccess = false;
        }, 3000);
      })
      return popupComponent.$mount().$el;
    },

    dataInCurrentSubsection(did) {
      // TODO: Do this better. @suhas what is the ES6 way to do this
      let dataIds = [];
      Array.from(this.currentSubsection.data).forEach((data)=> {
        dataIds.push(Number(data.data_id));
      })
      return dataIds.includes(Number(did));
    },

    plotPolylineLayers() {
      if (!this.currentSubsection.data) { return; }
      this.mainmapPolylineLayer.clearLayers();
      this.minimapPolylineLayer.clearLayers();
      if (!this.isVideosVisible) { return; }
      for (let i=0; i<this.projectVideosLoaded.length; i++) {
        let did = Number(this.projectVideosLoaded[i]);
        if (this.isAllProjectDataVisible || this.dataInCurrentSubsection(did)) {
          this.plotPositionTimeData(this.positionTimeDataCache[did], did);
        }
      }
      NProgress.done();
    },

    plotPositionTimeData(positionTimeData, did) {
      const latlngs = [];
      Array.from(positionTimeData).forEach((element) => {
        latlngs.push([element.lat, element.lng]);
      });

      // NOTE: As per leaflet documentation same layer cannot be added to multiple maps
      // and Polyline cannot have different colors to fill and stroke
      // So, We are drawing four polylines on map:
      // 1. Polyline background on mainmap
      // 2. Polyline to depict white color fill on mainmap
      // 3. Polyline background on minimap
      // 4. Polyline to depict white color fill on minimap
      // We can remove two polylines if the design doesn't have different fill and stroke colors
      const mainmapPolyline = this.drawPolyline(latlngs, this.mainmapPolylineLayer, {
        color: 'black',
        weight: 10,
        opacity: 0.5,
      }, did);

      const minimapPolyline = this.drawPolyline(latlngs, this.minimapPolylineLayer, {
        color: '#5f6edc',
        weight: 4,
        opacity: 1,
      }, did);

      if (Number(this.did) == Number(did)) {
        this.drawPolyline(latlngs, this.mainmapPolylineLayer, {
          color: 'white',
          weight: 2,
          opacity: 1,
        }, did);
        /*
        // Fitting bounds should be done elsewhere
        this.mainmap.fitBounds(mainmapPolyline.getBounds(), {
          padding: [80, 80],
        });
        this.minimap.fitBounds(minimapPolyline.getBounds(), {
          padding: [10, 10],
        });
        */
      }

      // this.minimap.panTo(latlngs[0]);

      // End Loading Symbol
    },

    drawPolyline(latlngs, map, options, did) {
      return L.polyline(latlngs, {
        color: options.color,
        weight: options.weight,
        opacity: options.opacity,
      })
        .addTo(map)
        .on('click', (e) => {
          this.polylineClickHandler(e, did);
           e.stopPropagation();
        });
    },
    DronemarkerDragHandler(latlng){
     this.updatePosDataFromMap(latlng);
     this.$root.$emit('playvideo');
    },
    polylineClickHandler(e, did) {
      this.updatePosDataFromMap(e.latlng);
      this.setDid(did);
      this.minimap.setZoom(16);
      this.$root.$emit('playvideo');
    },

    updateMarkerLocation(latlng) {
      this.mainmapDroneMarker.setLatLng(latlng);
      this.minimapDroneMarker.setLatLng(latlng);
      // this.minimap.fitBounds(this.minimapDroneMarker.getBounds());
    },

    updatePosDataFromMap(latlng) {
      const posData = {
        lat: 0,
        lng: 0,
        setter: '',
      };
      posData.lat = latlng.lat;
      posData.lng = latlng.lng;
      posData.setter = POSITION_TIME_DATA_SETTERS.MAP;
      this.setGlobalPosData(posData);
    },

    fitMapBounds(did=null) {
      if (!did) { did = this.did; }
      let positionTimeData = this.positionTimeDataCache[did];
      if (!positionTimeData) { return; }
      let latlngs = [];
      Array.from(positionTimeData).forEach((element) => {
        latlngs.push([element.lat, element.lng]);
      });
      let line = L.polyline(latlngs);
      let options = {};
      if (this.isVideoPlayerVisible) {
        // TODO: Hardcoded. Use fraction of width of map instead
        options = {paddingTopLeft: [600,0]};
      }
      this.mainmap.fitBounds(line.getBounds(), options);
    }, 
    // Map related functions end
    setDid(did) {
      this.setCurrentDid(did);
    },
  },
};
</script>


<style lang="scss">
@import "../../node_modules/leaflet/dist/leaflet.css";
@import "../../node_modules/leaflet-measure/dist/leaflet-measure.css";
@import '@/assets/sass/_variables.scss';
@import "../../node_modules/leaflet-draw/dist/leaflet.draw.css";

.mainmap {
  height: calc(100vh - 3.7rem);
  width: 100%;
  z-index: 1;
}

.minimap {
  border-radius: 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.5);
  border: solid 3px #ffffff;
  position: absolute;
  width: 10vw;
  height: 40vh;
  top: 5rem;
  right: 1rem;
  z-index: 1;
}

.leaflet-control-zoom {
  margin-top: 3rem !important;
}

.leaflet-draw-actions {
  display: none !important;
}

#panorama {
  height: calc(100vh - 3.7rem);
  width: auto;
}

.panorama-wrapper {
  border-left: 2px solid #000;
  z-index: 2;
  // box-shadow: -1px 1px 20px rgba(0, 0, 0, .5);
  position: relative;
}

.displayYaw {
  position: absolute;
  bottom: 1rem;
  padding: 1rem;
  left: 50%;
  transform: translateX(-50%);
  background-color: #141516;
  opacity: 0.8;
  color: #fff;
  z-index: 6; // make sure this is greater than all other z-index
  border-radius: 10px;
}

.screenshot-button {
  cursor: pointer;
}
</style>

